import React, { Component } from "react";
import Loading from "../../../hoc/Loading/Loading";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import DatePickerMulti from "react-multi-date-picker";
import orderBy from "lodash/orderBy";
import {
  Row,
  Table,
  Button,
  Alert,
  ModalHeader,
  Modal,
  ModalBody,
  Input,
  ModalFooter,
  Col,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import axios from "../../../axios";
import * as url from "../../../utils/url";

import { withRouter } from "react-router-dom";
import "../Groups.css";
import UserIcon3 from "../../../assets/user-image-plc/User_Icon_3.svg";
// import { BsArrowDownRightSquare, BsPerson, BiUserPlus } from "react-icons/bs";
import { BiDownArrowAlt, BiUpArrowAlt, BiUserPlus, BiX } from "react-icons/bi";

import moment from "moment";
import {
  DEFAULT_GROUP_METRICS_DATA,
  isUserRemoved,
  profilePicValidityCheck,
} from "../.././../utils/constants";
import { BiExport } from "react-icons/bi";
import {
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../weekly-wins/TableLayoutComponents";
import { isMobile } from "../../../utils/deviceInfo";
import ReactTooltip from "react-tooltip";
import MetricsMembers from "./MetricsMembers";
import MetricsEvents from "./MetricsEvents";
import MetricsResources from "./MetricsResources";
import MetricsPlanning from "./MetricsPlanning";
import MetricsAnalytics from "./MetricsAnalytics";
import ExportMetrics from "./ExportMetrics";
import If from "../../../components/Shared/If";
import MetricsFilterComponent from "./MetricsFilterComponent";
import { grpBannerImg } from "../../../utils/constants";

class GroupList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupsMetricsData: [],
      groupsMetricsDataCopy: [],
      group: null,
      currentUserRole: 10000,
      membersPopupOpen: false,
      members: [],
      eventsPopupOpen: false,
      resourcesPopupOpen: false,
      actionsPopupOpen: false,
      analyticsPopupOpen: false,
      dateRange: [],
      searchedTerm: "",
      loading: false,
    };
  }

  navCreateGrp = () => {
    this.props.history.push(
      `/home/groups/${this.props.user.profile.organizationId._id}/create`
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.searchedTerm !== prevState.searchedTerm) {
      this.applyFilters();
    }

    if (
      JSON.stringify(this.state.dateRange) !==
      JSON.stringify(prevState.dateRange)
    ) {
      this.applyFilters();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      );
    }

    if (
      JSON.stringify(this.props.filterParams) !==
      JSON.stringify(nextProps.filterParams)
    ) {
      console.log("--11111111");
      this.handleFilterChange(nextProps.filterParams);
    }
  }

  assignedUserCheck = (user) => {
    if (user && (user.firstName || user._id)) {
      let assignedUser = { ...user };

      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";
      let { profile } = this.props.user;

      assignedUserFullName = isUserRemoved(user)
        ? "Inactive User"
        : assignedUserFullName;
      return (
        <div className="" data-tip={assignedUserFullName}>
          {profilePicValidityCheck(assignedUser.profilePic) ? (
            <img
              src={assignedUser.profilePic || UserIcon3}
              height="30px"
              width="30px"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <span
              className="spotlightUserInitials"
              style={{ width: "30px" }}
              data-letters={this.getInitials(assignedUser)}
            ></span>
          )}
          <ReactTooltip />
        </div>
      );
    } else {
      return (
        <span className="assign-border-wrapper">
          <BiUserPlus size={"25px"} />
        </span>
      );
      // <BsPerson size={"25px"} className="actionsNoAssignee" />;
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  componentDidMount() {
    this.getGroupsMetricsData(this.props.filterParams);
  }

  getGroupsMetricsData = (payload) => {
    this.setState({ loading: true });
    axios
      .post(url.getGroupMetrics, { filters: payload })
      .then((response) => {
        const data = response.data.data.map((item) => ({
          ...item,
          members:
            item.members && Array.isArray(item.members) ? item.members : [],
          actionsCount: item.actionsCount || 0,
          chartCount: item.chartCount || 0,
          eventsCount: item.eventsCount || 0,
          toolsCount: item.toolsCount || 0,
        }));

        this.setState(
          {
            groupsMetricsData: [...data],
            groupsMetricsDataCopy: [...data],
            loading: false,
          },
          () => {
            if (this.props.sortParams.sortBy) {
              this.handleSortChange(
                this.props.sortParams.sortBy,
                this.props.sortParams.sortOrder
              );
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  };

  handleMembersPopup = (group) => {
    const { membersPopupOpen } = this.state;
    if (membersPopupOpen) {
      this.setState({
        group: null,
        membersPopupOpen: false,
      });
    } else {
      let payload = {
        groupId: group._id,
        modelName: "Users",
        noLoader: true,
        groupDoc: group,
      };

      axios
        .post(url.getSingleGroupItems, payload)
        .then(({ data }) => {
          this.setState({ members: data.data });

          this.setState({
            group: group,
            membersPopupOpen: true,
          });
        })
        .catch((err) => console.log("err", err));
    }
  };

  handleEventsPopup = (group) => {
    const { eventsPopupOpen } = this.state;
    if (eventsPopupOpen) {
      this.setState({
        group: null,
        eventsPopupOpen: false,
      });
    } else {
      this.setState({
        group: group,
        eventsPopupOpen: true,
      });
    }
  };

  handleResourcesPopup = (group) => {
    const { resourcesPopupOpen } = this.state;
    if (resourcesPopupOpen) {
      this.setState({
        group: null,
        resourcesPopupOpen: false,
      });
    } else {
      this.setState({
        group: group,
        resourcesPopupOpen: true,
      });
    }
  };

  handleActionsPopup = (group) => {
    const { actionsPopupOpen } = this.state;
    if (actionsPopupOpen) {
      this.setState({
        group: null,
        actionsPopupOpen: false,
      });
    } else {
      this.setState({
        group: group,
        actionsPopupOpen: true,
      });
    }
  };

  handleAnalyticsPopup = (group) => {
    const { analyticsPopupOpen } = this.state;
    if (analyticsPopupOpen) {
      this.setState({
        group: null,
        analyticsPopupOpen: false,
      });
    } else {
      this.setState({
        group: group,
        analyticsPopupOpen: true,
      });
    }
  };

  gotToGroup = (item) => {
    let { profile } = this.props.user;
    this.props.history.push(
      `/home/groups/${profile.organizationId._id}/view/${item._id}`
    );
  };

  handleSearchQueryChanged = (e) => {
    this.setState({ searchedTerm: e.target.value });
  };

  handleDateChange = (dates) => {
    console.log("dates --- ", dates);
    this.setState({ dateRange: [...dates].map((x) => new Date(x)) });
  };

  clearDates = () => {
    this.setState({ dateRange: [] });
  };

  applyFilters = () => {
    const { searchedTerm, dateRange } = this.state;
    let metricsdata = [...this.state.groupsMetricsDataCopy];

    if (searchedTerm) {
      metricsdata = metricsdata.filter((x) =>
        x.name.toLowerCase().includes(searchedTerm.toLowerCase())
      );
    }
    if (dateRange && dateRange.length) {
      const start = dateRange[0];
      const end = dateRange[1];

      if (start && end) {
        metricsdata = metricsdata.filter((x) =>
          moment(x.createdOn).isBetween(start, end)
        );
      }
    }

    this.setState({ groupsMetricsData: [...metricsdata] });
  };

  clearFilters = () => {
    this.setState({
      groupsMetricsData: [...this.state.groupsMetricsDataCopy],
      searchedTerm: "",
      dateRange: [],
    });
  };

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  sortComponent = (key) => {
    const { sortParams } = this.props;
    // console.log('key --- ', key)
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(key) &&
      sortParams.sortOrder === "asc"
    ) {
      return (
        <BiDownArrowAlt
          size={"18px"}
          onClick={() => this.changeSortField(key, "desc")}
        />
      );
    } else {
      return (
        <BiUpArrowAlt
          size={"18px"}
          onClick={() => this.changeSortField(key, "asc")}
        />
      );
    }
  };

  handleSortChange = (key, order) => {
    let todos = [...this.state.groupsMetricsData];

    switch (key) {
      case "name":
        todos = orderBy(todos, (itm) => itm["name"].toLowerCase(), [order]);
        break;

      case "groupOwner":
        let valid = todos.filter((itm) => itm.groupAdmin);
        let rest = todos.filter((itm) => !itm.groupAdmin);
        valid = orderBy(
          valid,
          (itm) => {
            const name = `${itm.groupAdmin.firstName || ""} ${itm.groupAdmin
              .lastName || ""}`;
            return name;
          },
          [order]
        );
        todos = [...valid, ...rest];
        break;

      case "createdOn":
        let validDates = todos.map((itm) => ({
          ...itm,
        }));
        validDates = orderBy(
          validDates,
          (itm) => moment(itm[key] || new Date(8640000000000000)),
          [order]
        );

        todos = [...validDates];

        break;

      case "membersCount":
        todos = orderBy(
          todos,
          (itm) => (itm.members ? itm.members.length : itm.members),
          [order]
        );
        break;
      case "actionsCount":
        todos = orderBy(todos, (itm) => itm.actionsCount, [order]);
        break;
      case "toolsCount":
        todos = orderBy(todos, (itm) => itm.toolsCount, [order]);
        break;
      case "analyticsCount":
        todos = orderBy(todos, (itm) => itm.chartCount, [order]);
        break;
      case "eventCount":
        todos = orderBy(todos, (itm) => itm.eventCount, [order]);
        break;

      default:
        todos = orderBy(todos, (itm) => itm[key], [order]);
        break;
    }
    this.setState({ groupsMetricsData: todos });
  };

  handleFilterChange = (filter) => {
    console.log("changedddddddddd");
    this.getGroupsMetricsData(filter);
  };

  render() {
    const tableCols = {
      name: 3,
      groupOwner: 2,
      createdAt: 2,
      members: 1,
      actions: 1,
      analytics: 1,
      events: 1,
      resources: 1,
    };

    const tableColsMobile = {
      groupOwner: 2,
      createdAt: 3,
      members: 1,
      actions: 1,
      analytics: 2,
      events: 1,
      resources: 2,
    };

    const {
      membersPopupOpen,
      group,
      eventsPopupOpen,
      resourcesPopupOpen,
      actionsPopupOpen,
      analyticsPopupOpen,
      searchedTerm,
      dateRange,
      groupsMetricsData,
    } = this.state;

    const { filterParams, renderTableForAnalytics } = this.props;

    const tableUI = (
      <div>
        {groupsMetricsData && groupsMetricsData.length > 0 ? (
          <div
            id="metrics-table-layout"
            className={`actions-table-div ${
              renderTableForAnalytics ? "" : "my-4"
            } p0 bx-shadow-actions`}
          >
            <LayoutRow className="row-fixed-25h">
              {!isMobile && (
                <LayoutHeading
                  className={"justify-content-center"}
                  colWidth={tableCols.name}
                >
                  Name {this.sortComponent("name")}
                </LayoutHeading>
              )}

              {isMobile && (
                <Col xs={5} className="px-0">
                  <Row>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={12}
                    >
                      Name {this.sortComponent("name")}
                    </LayoutHeading>
                  </Row>

                  {this.state.groupsMetricsData.map((item, idx) => {
                    return (
                      <Row key={idx} className={"planning-row-mobile-height"}>
                        <LayoutData colWidth={12}>
                          <div
                            data-tip={item.name}
                            className="todo-item-title font-weight-bold cursor-pointer"
                            onClick={() => this.gotToGroup(item)}
                          >
                            {item.name}
                          </div>
                          <ReactTooltip />
                        </LayoutData>
                      </Row>
                    );
                  })}
                </Col>
              )}

              {isMobile ? (
                <Col xs={7} className="scrollable-action-table-row px-0">
                  <Row className="row-scroll-width-s">
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.createdBy}
                    >
                      Group Admin {this.sortComponent("createdBy")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.createdAt}
                    >
                      Created On {this.sortComponent("createdOn")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.members}
                    >
                      Members {this.sortComponent("membersCount")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.events}
                    >
                      Events {this.sortComponent("eventCount")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.resources}
                    >
                      Resources {this.sortComponent("toolsCount")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.actions}
                    >
                      Actions {this.sortComponent("actionsCount")}
                    </LayoutHeading>
                    <LayoutHeading
                      className={"justify-content-center"}
                      colWidth={tableColsMobile.analytics}
                    >
                      Analytics {this.sortComponent("analyticsCount")}
                    </LayoutHeading>
                  </Row>
                  {this.state.groupsMetricsData.map((item, idx) => {
                    return (
                      <LayoutRow
                        key={idx}
                        className={`pl-tasks-row ${
                          isMobile ? "row-scroll-width-s" : ""
                        }`}
                      >
                        <LayoutData colWidth={tableColsMobile.createdBy}>
                          <div className={`metrics-created-by`}>
                            <div>{this.assignedUserCheck(item.createdBy)}</div>

                            <ReactTooltip />
                          </div>
                        </LayoutData>
                        <LayoutData colWidth={tableColsMobile.createdAt}>
                          <span className="metrics-date-text">
                            {moment(item.createdOn).format("MMM D, YYYY")}
                          </span>
                        </LayoutData>
                        <LayoutData colWidth={tableColsMobile.members}>
                          <span
                            className="metrics-data-count"
                            onClick={() => this.handleMembersPopup(item)}
                          >
                            {item.members.length}
                          </span>
                        </LayoutData>
                        <LayoutData colWidth={tableColsMobile.events}>
                          <span
                            className="metrics-data-count"
                            onClick={() => this.handleEventsPopup(item)}
                          >
                            {item.eventCount}
                          </span>
                        </LayoutData>
                        <LayoutData colWidth={tableColsMobile.resources}>
                          <span
                            className="metrics-data-count"
                            onClick={() => this.handleResourcesPopup(item)}
                          >
                            {item.toolsCount}
                          </span>
                        </LayoutData>

                        <LayoutData colWidth={tableColsMobile.actions}>
                          <span
                            className="metrics-data-count"
                            onClick={() => this.handleActionsPopup(item)}
                          >
                            {item.actionsCount}
                          </span>
                        </LayoutData>
                        <LayoutData colWidth={tableColsMobile.analytics}>
                          <span
                            className="metrics-data-count"
                            onClick={() => this.handleAnalyticsPopup(item)}
                          >
                            {item.chartCount}
                          </span>
                        </LayoutData>
                      </LayoutRow>
                    );
                  })}
                </Col>
              ) : (
                <If condition={true}>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.createdBy}
                  >
                    Created By {this.sortComponent("createdBy")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.createdAt}
                  >
                    Created On {this.sortComponent("createdOn")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.members}
                  >
                    Members {this.sortComponent("membersCount")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.events}
                  >
                    Events {this.sortComponent("eventCount")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.resources}
                  >
                    Resources {this.sortComponent("toolsCount")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.actions}
                  >
                    Actions {this.sortComponent("actionsCount")}
                  </LayoutHeading>
                  <LayoutHeading
                    className={"justify-content-center"}
                    colWidth={tableCols.analytics}
                  >
                    Analytics {this.sortComponent("analyticsCount")}
                  </LayoutHeading>
                </If>
              )}
            </LayoutRow>

            <div className="trivia_survey_list_table_contents_scroll px-0 mx-0 no-scr-mob">
            {!isMobile &&
              this.state.groupsMetricsData.map((item, idx) => {
                return (
                  <LayoutRow key={idx}>
                    <LayoutData colWidth={tableCols.name}>
                      <div
                        data-tip={item.name}
                        className="todo-item-title font-weight-bold cursor-pointer"
                        onClick={() => this.gotToGroup(item)}
                      >
                        {item.name}
                      </div>
                      <ReactTooltip />
                    </LayoutData>

                    <LayoutData colWidth={tableCols.createdBy}>
                      <div className={`metrics-created-by`}>
                        <div>{this.assignedUserCheck(item.createdBy)}</div>

                        <ReactTooltip />
                      </div>
                    </LayoutData>
                    <LayoutData colWidth={tableCols.createdAt}>
                      <span className="metrics-date-text">
                        {moment(item.createdOn).format("MMM D, YYYY")}
                      </span>
                    </LayoutData>
                    <LayoutData colWidth={tableCols.members}>
                      <span
                        className="metrics-data-count"
                        onClick={() => this.handleMembersPopup(item)}
                      >
                        {item.members.length}
                      </span>
                    </LayoutData>
                    <LayoutData colWidth={tableCols.events}>
                      <span
                        className="metrics-data-count"
                        onClick={() => this.handleEventsPopup(item)}
                      >
                        {item.eventCount}
                      </span>
                    </LayoutData>
                    <LayoutData colWidth={tableCols.resources}>
                      <span
                        className="metrics-data-count"
                        onClick={() => this.handleResourcesPopup(item)}
                      >
                        {item.toolsCount}
                      </span>
                    </LayoutData>

                    <LayoutData colWidth={tableCols.actions}>
                      <span
                        className="metrics-data-count"
                        onClick={() => this.handleActionsPopup(item)}
                      >
                        {item.actionsCount}
                      </span>
                    </LayoutData>
                    <LayoutData colWidth={tableCols.analytics}>
                      <span
                        className="metrics-data-count"
                        onClick={() => this.handleAnalyticsPopup(item)}
                      >
                        {item.chartCount}
                      </span>
                    </LayoutData>
                  </LayoutRow>
                );
              })}
            </div>

            
          </div>
        ) : this.state.loading ? (
          <div>
            {renderTableForAnalytics ? (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background:"white"
                }}
              >
                <h5 className="text-center">Loading...</h5>
              </div>
            ) : (
              <h5 className="text-center">Loading...</h5>
            )}
          </div>
        ) : (
          <div className="col-md-5 grp_list_page_item_container">
            <div className="card linkedChartItemStyling group_list_items_container group_list_items_001">
              <img
                src={grpBannerImg}
                className="banner_filter"
                onClick={() => this.navCreateGrp()}
              />

              <div className="card-body">
                <span onClick={() => this.navCreateGrp()}>
                  <span className="grp_list_no_groups_txt">
                    No groups have been created Click Here to create a group
                  </span>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );

    if (renderTableForAnalytics) {
      return <div className="metrics_list_table">{tableUI}</div>;
    } else {
      return (
        <div className="groups-metrics-container ">
          <div className="grp_list_page_container-metrics col-md-12 col-lg-12 col-sm-12">
            <div className="grp_list_page_container_title">Groups Metrics</div>
            {groupsMetricsData && groupsMetricsData.length > 0 ? (
              <div
                className="grp_list_page_container_createBtn"
                style={{ float: isMobile ? "none" : "right" }}
              >
                <ExportMetrics groupMetrics={this.state.groupsMetricsData} />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="d-flex">
            <div>
              {groupsMetricsData && groupsMetricsData.length > 0 ? (
                <MetricsFilterComponent
                  filterParams={this.props.filterParams}
                  updateFilterParams={this.props.updateFilterParams}
                />
              ) : Object.keys(filterParams.filtersDoc).length > 0 ? (
                <MetricsFilterComponent
                  filterParams={this.props.filterParams}
                  updateFilterParams={this.props.updateFilterParams}
                />
              ) : (
                ""
              )}
            </div>
          </div>

          {/* <Row className={"my-4"}>
            <Col md={7} xs={12} className={isMobile && "mb-4"}>
              <InputGroup style={{ height: "40px", width: "90%" }}>
                <Input
                  className="toolkit-field tool-search-box"
                  placeholder="Search by group name"
                  onChange={this.handleSearchQueryChanged}
                  value={searchedTerm}
                />
                <InputGroupAddon addonType="append">
                  <i
                    style={{ color: "#818389", padding: "7px" }}
                    className="flaticon-search"
                  ></i>
                </InputGroupAddon>
              </InputGroup>
            </Col>
            <Col md={3} xs={12}>
              <DatePickerMulti
                value={dateRange}
                onChange={this.handleDateChange}
                range
                inputClass="custom-mdate-action-filterinput"
                placeholder="Date Range (Created On)"
                style={{ width: isMobile ? "82vw" : "259px" }}
              />
            </Col>
            <Col md={2} xs={12} style={{ margin: "auto" }}>
              <span
                onClick={this.clearDates}
                className="group-metrics-clear-dates"
              >
                <BiX size="15px" /> Clear dates
              </span>
            </Col>
          </Row> */}

          {tableUI}

          {membersPopupOpen && group && (
            <MetricsMembers
              {...this.state}
              removeMember={() => {}}
              highlightMenu={() => {}}
              renderIntoMetricsPopup
              membersPopupOpen={membersPopupOpen}
              toggle={this.handleMembersPopup}
            />
          )}

          {eventsPopupOpen && group && (
            <MetricsEvents
              {...this.state}
              highlightMenu={() => {}}
              renderIntoMetricsPopup
              eventsPopupOpen={eventsPopupOpen}
              toggle={this.handleEventsPopup}
            />
          )}

          {resourcesPopupOpen && group && (
            <MetricsResources
              {...this.state}
              highlightMenu={() => {}}
              renderIntoMetricsPopup
              resourcesPopupOpen={resourcesPopupOpen}
              toggle={this.handleResourcesPopup}
            />
          )}

          {actionsPopupOpen && group && (
            <MetricsPlanning
              {...this.state}
              highlightMenu={() => {}}
              renderIntoMetricsPopup
              actionsPopupOpen={actionsPopupOpen}
              toggle={this.handleActionsPopup}
            />
          )}

          {analyticsPopupOpen && group && (
            <MetricsAnalytics
              {...this.state}
              highlightMenu={() => {}}
              renderIntoMetricsPopup
              analyticsPopupOpen={analyticsPopupOpen}
              toggle={this.handleAnalyticsPopup}
            />
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.groupMetrics
        ? state.sortFilterParams.groupMetrics.sort &&
          state.sortFilterParams.groupMetrics.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.groupMetrics.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
    filterParams: state.sortFilterParams.groupMetrics
      ? state.sortFilterParams.groupMetrics.filter
      : { filtersDoc: {} },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    updateSortParams: (data) =>
      dispatch(actionCreators.updateGroupMetricsSort(data)),
    updateFilterParams: (data) =>
      dispatch(actionCreators.updateGroupMetricsFilter(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Loading(GroupList, axios))
);
